import styled, { css } from 'styled-components';

export const SkipLink = styled.a(
  ({ theme }) => css`
    ${theme.typography.button.l};
    position: absolute;
    background: ${theme.co.primary20};
    color: ${theme.co.neutral0};
    padding: ${theme.sz.s3};
    z-index: ${theme.zi.modal};
    transform: translateY(-100%);
    transition: transform 0.3s;
    text-decoration: none;
    min-width: 100%;
    text-align: center;

    &:focus-visible {
      transform: translateY(0);
    }
  `,
);
